import type { FormatterMap, ProductRoutesOptions, RouteList } from '@grandvisionhq/frk-routing'
import { createSimpleFormatter } from '@grandvisionhq/frk-routing'
import {
  createAuthFormatters,
  createCheckoutFormatters,
  createMyAccountFormatters,
  productDetailFormatters,
  productListFormatter,
} from '@grandvisionhq/www-next/formatters'

const productRoutesOptions: ProductRoutesOptions = {
  'contact-lenses': 'lentes-de-contacto',
  frames: 'gafas-graduadas',
  'ready-readers': 'gafas-de-lectura',
  solutions: 'solutions',
  sunglasses: 'gafas-de-sol',
  accessories: 'accesorios',
}

export const localRouteFormatters: FormatterMap = {
  home: createSimpleFormatter('/'),
  'cart.overview': createSimpleFormatter('cart'),
  'appointments.book': createSimpleFormatter('pide-cita'),
  'appointments.cancel': createSimpleFormatter('cancel-appointment'),
  'appointments.reschedule': createSimpleFormatter('reschedule-appointment'),
  ...createAuthFormatters(),
  ...createMyAccountFormatters(),
  'express-checkout': createSimpleFormatter('express-checkout'),
  'express.checkout.login': createSimpleFormatter('express-user-checkout'),
  'order.confirm': createSimpleFormatter('order/confirm'),
  ...createCheckoutFormatters({
    path: 'checkout',
    children: { shipping: 'shipping', overview: 'overview', payment: 'payment' },
  }),
  ...productListFormatter(productRoutesOptions),
  ...productDetailFormatters(productRoutesOptions),
  returns: createSimpleFormatter('/devoluciones'),
  'returns.select-items': createSimpleFormatter('/devoluciones/seleccionar-articulos'),
  'returns.confirmation': createSimpleFormatter('/devoluciones/confirmacion'),
  wishlist: createSimpleFormatter('/wishlist'),
}

export const routes: RouteList = [
  ['/', 'home'],

  ['/checkout/shipping', 'checkout.shipping'],
  ['/checkout/overview', 'checkout.overview'],
  ['/checkout/payment', 'checkout.payment'],
  ['/api/payment-callback', 'payment.callback'],
  ['/order/confirm', 'order.confirm'],

  ['/express-checkout', 'express-checkout'],

  ['/pide-tu-cita{/*path}', 'appointments.book'],
  ['/cancela-tu-cita', 'appointments.cancel'],
  ['/reprograma-tu-cita', 'appointments.reschedule'],
]
